import { create } from 'zustand';

/**
 * Ephemeral, per-turn video context, sent as `turnMetadata` on every
 * `sendMessage`. Module-singleton so the chat container reads it directly; the
 * exported setters (and a later cross-root Magpie hook) write into it, so their
 * signatures must stay stable. For lifecycle-scoped use see
 * `../hooks/useAcademyAssistantContext`.
 */

/** Token identifying the last writer, so an unmount only clears its own context. */

const EMPTY_CONTEXT = {};
export const useAcademyAssistantContextStore = create(set => ({
  context: EMPTY_CONTEXT,
  owner: null,
  setContext: (context, owner = null) => set({
    context,
    owner
  }),
  clearContext: () => set({
    context: EMPTY_CONTEXT,
    owner: null
  }),
  clearContextIfOwner: owner => set(state => state.owner === owner ? {
    context: EMPTY_CONTEXT,
    owner: null
  } : state)
}));

/** Imperatively replace the context. Safe to call from outside React. */
export const setAcademyAssistantContext = context => {
  useAcademyAssistantContextStore.getState().setContext(context);
};

/** Reset the context back to empty. */
export const clearAcademyAssistantContext = () => {
  useAcademyAssistantContextStore.getState().clearContext();
};

/** Non-reactive snapshot read, for reading fresh context at send time. */
export const getAcademyAssistantContext = () => useAcademyAssistantContextStore.getState().context;